import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  Cpt4CodesState,
  Cpt4CodesAction,
  Cpt4CodeTypes
} from '../types'

export const initState: Cpt4CodesState = {
  isFetching: false,
  data: {
    content: [],
    size: 0,
    totalPages: 0,
    number: 0
  },
  errors: {
      fetchingError: false,
      creatingError: false,
      updatingError: false,
      deletingError: false,
  }
}

export const cpt4CodesReducer: Reducer<Cpt4CodesState> = createReducer<
  Cpt4CodesState,
  Cpt4CodesAction
>(initState, {
  [Cpt4CodeTypes.FETCH_CPT4_CODES_REQUEST]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: true,
    errors: { ...state.errors, fetchingError: false }
    // data: { content: [], size: 0 }
  }),
  [Cpt4CodeTypes.FETCH_CPT4_CODES_SUCCESS]: (
    state: Cpt4CodesState,
    action
  ) => ({
    ...state,
    isFetching: false,
    data: {
        content: action.payload.content,
        size: action.payload.size,
        totalPages: action.payload.totalPages,
        number: action.payload.number
    },
    errors: { ...state.errors, fetchingError: false }
  }),
  [Cpt4CodeTypes.FETCH_CPT4_CODES_FAIL]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, fetchingError: true }
  }),
  [Cpt4CodeTypes.CREATE_CPT4_CODES_REQUEST]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: true,
    errors: { ...state.errors, creatingError: false }
  }),
  [Cpt4CodeTypes.CREATE_CPT4_CODES_SUCCESS]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, creatingError: false }
  }),
  [Cpt4CodeTypes.CREATE_CPT4_CODES_FAIL]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, creatingError: true }
  }),
  [Cpt4CodeTypes.UPDATE_CPT4_CODES_REQUEST]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: true,
    errors: { ...state.errors, updatingError: false }
  }),
  [Cpt4CodeTypes.UPDATE_CPT4_CODES_SUCCESS]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, updatingError: false }
  }),
  [Cpt4CodeTypes.UPDATE_CPT4_CODES_FAIL]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, updatingError: true }
  }),
  [Cpt4CodeTypes.DELETE_CPT4_CODES_REQUEST]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: true,
    errors: { ...state.errors, deletingError: false }
  }),
  [Cpt4CodeTypes.DELETE_CPT4_CODES_SUCCESS]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, deletingError: false }
  }),
  [Cpt4CodeTypes.DELETE_CPT4_CODES_FAIL]: (state: Cpt4CodesState) => ({
    ...state,
    isFetching: false,
    errors: { ...state.errors, deletingError: true }
  }),
})

export default cpt4CodesReducer
